import React from 'react'
import { FormattedMessage } from 'react-intl'
import Text from 'src/Components/Text'

const ExtraPrincipalTeaserText = props => (
  <Text.Headline {...props}>
    <FormattedMessage
      id='ExtraPrincipalTeaser.headline'
      defaultMessage='See the wealth power of extra principal payments'
    />
  </Text.Headline>
)

export default ExtraPrincipalTeaserText
